import React from 'react';
import DomainCoverageWidget from './DomainCoverageWidget';
import SourceHealthMatrix from './SourceHealthMatrix';

const LEVEL_COLORS = {
  NOMINAL: '#00E5FF',
  ELEVATED: '#FF9F0A',
  STORM: '#FF6B35',
  EXTREME: '#FF3B30',
};

export default function OrionLeftPanel({ state, scoring, insights }) {
  const levelColor = LEVEL_COLORS[state?.level] || '#00E5FF';
  const activeFocus = state?.active_focus || [];
  const confidence = scoring?.finalConfidenceScore;

  return (
    <div className="orion-left" data-testid="orion-left-panel">
      {/* Orion Avatar */}
      <div className="orion-avatar-wrap">
        <div className="orion-avatar-outer">
          <div className="orion-orbit" style={{ borderColor: `${levelColor}30` }}>
            <div className="orion-orbit-dot" style={{ background: levelColor, boxShadow: `0 0 6px ${levelColor}` }} />
          </div>
          <div className="orion-avatar-core" data-testid="orion-avatar">
            <svg viewBox="0 0 40 40" className="orion-avatar-svg">
              <circle cx="12" cy="8" r="1.5" fill={levelColor} opacity="0.9" />
              <circle cx="16" cy="14" r="1.2" fill={levelColor} opacity="0.7" />
              <circle cx="20" cy="20" r="2" fill={levelColor} />
              <circle cx="24" cy="26" r="1.2" fill={levelColor} opacity="0.7" />
              <circle cx="28" cy="32" r="1.5" fill={levelColor} opacity="0.9" />
              <line x1="12" y1="8" x2="16" y2="14" stroke={levelColor} strokeWidth="0.5" opacity="0.4" />
              <line x1="16" y1="14" x2="20" y2="20" stroke={levelColor} strokeWidth="0.5" opacity="0.4" />
              <line x1="20" y1="20" x2="24" y2="26" stroke={levelColor} strokeWidth="0.5" opacity="0.4" />
              <line x1="24" y1="26" x2="28" y2="32" stroke={levelColor} strokeWidth="0.5" opacity="0.4" />
              <circle cx="8" cy="18" r="1" fill="#A1A1AA" opacity="0.5" />
              <circle cx="32" cy="22" r="1" fill="#A1A1AA" opacity="0.5" />
              <line x1="8" y1="18" x2="20" y2="20" stroke="#A1A1AA" strokeWidth="0.3" opacity="0.3" />
              <line x1="32" y1="22" x2="20" y2="20" stroke="#A1A1AA" strokeWidth="0.3" opacity="0.3" />
            </svg>
          </div>
        </div>
        <div className="orion-avatar-name">ORION</div>
        <div className="orion-avatar-state" style={{ color: levelColor }} data-testid="orion-state-level">{state?.level || 'NOMINAL'}</div>
      </div>

      {/* Confidence from scoring engine */}
      <div className="orion-conf">
        <div className="orion-conf-row">
          <span className="orion-conf-label">CONFIDENCE</span>
          <span className="orion-conf-val" style={{ color: levelColor }}>{confidence !== undefined ? `${confidence.toFixed(0)}` : '—'}</span>
        </div>
        <div className="orion-bar-track">
          <div className="orion-bar-fill" style={{ width: `${confidence || 0}%`, background: levelColor }} />
        </div>
      </div>

      {/* Domain Coverage Widget */}
      <div className="orion-section" data-testid="orion-domain-coverage">
        <div className="orion-section-label">DOMAIN COVERAGE</div>
        <DomainCoverageWidget scoring={scoring} domainCoverage={state?.domain_coverage} />
      </div>

      {/* Active Focus */}
      {activeFocus.length > 0 && (
        <div className="orion-section" data-testid="orion-active-focus">
          <div className="orion-section-label">ACTIVE FOCUS</div>
          {activeFocus.slice(0, 4).map((f, i) => (
            <div key={i} className="orion-focus-row">
              <span className="orion-focus-cat">{f.category}</span>
              <span className="orion-focus-detail">{f.detail}</span>
            </div>
          ))}
        </div>
      )}

      {/* Source Health Matrix */}
      <SourceHealthMatrix scoring={scoring} />
    </div>
  );
}
